import { get, post, del } from '../../api';

export const getBloqueios = () => {
  return get('/api/conectores/bloqueios');
};

export const postBloqueio = (data) => {
  return post('/api/conectores/bloqueio', data);
};

export const deleteBloqueio = (conectorIdentify) => {
  return del(`/api/conectores/bloqueio/${conectorIdentify}`);
};
